module.exports = __webpack_public_path__ + "c55042315115d98d1edb662619f839e9.jpg";